/**
 * @voltxampere/engine — Transient stamp context factory
 *
 * Wraps {@link createDCStampContext} with the extra transient-only
 * fields ({@link TransientStampContext.h}, `method`, `xPrevPrev`,
 * `firstStep`, `previousCurrent`). The DC factory already covers
 * the matrix bookkeeping (`addY`, `nodeIndex`, …) so we delegate to
 * it and decorate the result.
 *
 * Copyright © 2026 360 Studio
 * Licensed under MIT (see LICENSE file in repo root)
 */
import { ContractViolationError } from "@voltxampere/shared";
import { createDCStampContext } from "../context.js";
export function createTransientStampContext(deps) {
    if (!(deps.h > 0) || !Number.isFinite(deps.h)) {
        throw new ContractViolationError(`createTransientStampContext: h must be a positive finite number, got ${String(deps.h)}`);
    }
    if (!(deps.hPrev > 0) || !Number.isFinite(deps.hPrev)) {
        throw new ContractViolationError(`createTransientStampContext: hPrev must be a positive finite number, got ${String(deps.hPrev)}`);
    }
    if (deps.xStepPrev.length !== deps.xPrev.length) {
        throw new ContractViolationError(`createTransientStampContext: xStepPrev length ${String(deps.xStepPrev.length)} ≠ xPrev length ${String(deps.xPrev.length)}`);
    }
    if (deps.xStepPrevPrev !== null && deps.xStepPrevPrev.length !== deps.xPrev.length) {
        throw new ContractViolationError(`createTransientStampContext: xStepPrevPrev length ${String(deps.xStepPrevPrev.length)} ≠ xPrev length ${String(deps.xPrev.length)}`);
    }
    if (deps.firstStep && deps.xStepPrevPrev !== null) {
        throw new ContractViolationError(`createTransientStampContext: firstStep=true requires xStepPrevPrev=null`);
    }
    const dcCtx = createDCStampContext(deps);
    return {
        ...dcCtx,
        h: deps.h,
        hPrev: deps.hPrev,
        method: deps.method,
        firstStep: deps.firstStep,
        xStepPrev: deps.xStepPrev,
        xStepPrevPrev: deps.xStepPrevPrev,
        previousCurrent: deps.previousCurrent,
    };
}
//# sourceMappingURL=context.js.map